import { createSlice } from '@reduxjs/toolkit';
import FilterService from '../../../services/FilterService';

interface IActiveFilter {
  id?: string;
  title?: string;
  subTitle?: string;
  count?: number;
  type?: number;
  enabled?: boolean;
  enableNotification?: boolean;
}

export interface ICriteria {
  inputDefinitions?: Array<{ key: string; value: string }>;
  mileage: { start: number; end: number; odometerType: number | null };
  modelTrims:
    | Array<{
        model: {
          manufacturerId: number;
          displayName: string;
        };
      }>
    | [];
  modelYear: { start: number; end: number };
  fuelTypes: Array<{ id: string }> | [];
  transmissionTypes: Array<{ id: number }> | [];
  locationFilter:
    | {
        distance?: number;
        index?: number;
        dropoffAddressId?: number;
        location?: { latitude: number; longitude: number };
        postalCode?: string;
        odometerType?: number;
      }
    | {};
  isAsIs?: boolean;
  isWishList?: boolean;
  isInStock?: boolean;
  isFloorPriceMet?: boolean;
  isFranchiseDealer?: boolean;
}

export interface IFilterCriteria {
  id?: string;
  criteria: ICriteria;
}
interface FilterState {
  activeFilter: IActiveFilter;
  filterCriteria: IFilterCriteria | {};
  previewCriteria: ICriteria | {};
  activeNetwork: { [key: string]: string };
  filterMetaData;
}

const initialState: FilterState = {
  activeFilter: FilterService.initializeActiveListId(),
  filterCriteria: {},
  previewCriteria: {},
  activeNetwork: FilterService.initializeActiveNetorkId(),
  filterMetaData: {}
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setActiveFilter(state, action) {
      return {
        ...state,
        activeFilter: action.payload,
        previewCriteria: {}
      };
    },
    setActiveFilterFromUrl(state, action) {
      return {
        ...state,
        activeFilter: action.payload
      };
    },

    initializeActiveFilter(state, action) {
      return {
        ...state,
        activeFilter: FilterService.getDefaultActiveListId(action.payload)
      };
    },
    setFilterCriteria(state, action) {
      return {
        ...state,
        filterCriteria: action.payload
      };
    },
    setPreviewCriteria(state, action) {
      return {
        ...state,
        previewCriteria: action.payload
      };
    },
    setActiveNetwork(state, action) {
      return {
        ...state,
        activeNetwork: action.payload
      };
    },
    setActiveFilterMetaData(state, action) {
      return {
        ...state,
        filterMetaData: action.payload
      };
    }
  }
});

export const selectActiveFilter = state => state.filter.activeFilter;

export const {
  setActiveFilter,
  setActiveFilterFromUrl,
  initializeActiveFilter,
  setFilterCriteria,
  setPreviewCriteria,
  setActiveNetwork,
  setActiveFilterMetaData
} = filterSlice.actions;

export default filterSlice.reducer;
